/**
 * Emoji Api
 * 필수 parameter : clipId, unicode, emojiType
 */
// Emoji 생성
export async function setCreateEmoji(app, clipId, unicode, emojiType, positionX, positionY, emojiTime) {
  return await app.$axios.post('/v1/emoji/create', {
    clipId,
    unicode,
    emojiType,
    positionX,
    positionY,
    emojiTime,
  })
}
// Emoji 리스트 호출
export async function getEmojiList(app, clipId) {
  return await app.$axios.post('/v1/emoji/list', {
    clipId,
  })
}

/**
 * Emoji 삭제
 * @param {*} clipId 클립 ID
 * @param {*} emojiId 이모지 ID
 * @param {*} deleteType 단일삭제 : emoji
 * @returns new value
 */
export async function setDeleteEmoji(app, clipId, emojiId, deleteType) {
  return await app.$axios.post('/v1/emoji/delete', {
    clipId,
    emojiId,
    deleteType,
  })
}
